/** Customer-facing task families, by the icon each renders under in catalog and landing merchandising. */
export const DATA_CAPABILITY_ICONS: Readonly<Record<string, string>> = {
  company_search: 'building-search',
  people_search: 'user-search',
  company_enrichment: 'building-data',
  company_identify: 'target',
  person_enrichment: 'identity-card',
  contact_enrichment: 'at-sign',
  email_finding: 'mail-search',
  email_verification: 'mail-check',
  mobile_phone: 'smartphone',
  job_search: 'briefcase',
  property_records: 'home',
  technographics: 'code',
};

/** Platform-card prefixes presented together in the catalog's Enrichment category.
 *
 *  `email` (Email Finder, Email Verifier), `social` (Social Profile Finder) and
 *  `person` (Skip Trace) arrive from the gateway under `data`, which puts
 *  contact lookup beside job boards and property listings. They are the same
 *  job as the task families above, so they are merchandised with them.
 *  Discovery categories are unchanged - this is a browse decision, not a
 *  catalog one. */
export const ENRICHMENT_PLATFORM_IDS: ReadonlySet<string> = new Set([
  ...Object.keys(DATA_CAPABILITY_ICONS),
  'apollo',
  'email',
  'social',
  'person',
]);
